import {
    CUSTOM_SEGMENT_CREATED_UPDATED,
    DELETE_SEGMENT_GROUP_SUCCESS,
    GROUP_CREATED_UPDATED,
    GROUP_DELETED,
    RECEIVE_SEGMENTS_MODULE_META_DATA,
    REQUEST_SEGMENTS_MODULE_META_DATA,
    TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL,
    TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
    SHOW_NO_ACCESS_MODAL,
    SET_ENABLED_WIDGETS,
    RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA,
    UPDATE_UNIQUE_SEGMENTS_IDS,
} from "app/action_types/segments_module_action_types";
import type {
    DashboardSegmentsMeta,
    ICustomSegmentsGroup,
    ICustomSegmentsMetaData,
    WidgetAvailability,
} from "app/services/segments/segmentsApiService";

export interface ISegmentsModuleState {
    segmentGroup: ICustomSegmentsGroup | undefined;
    segmentWidgetAvailability: WidgetAvailability | undefined;
    createUpdateGroupSegmentModalIsOpen: boolean;
    deleteSegmentGroupIsOpen: boolean;
    customSegmentsMeta?: ICustomSegmentsMetaData;
    dashboardSegmentsMeta?: DashboardSegmentsMeta;
    segmentsLoading: false;
    compareToSegment: string | undefined;
    shouldShowNoAccessModal: boolean;
}

/**
 * Get default state. id the screen width is less than 1200px, the sidebar is closed by default;
 * @returns {ILayoutState}
 */
function getDefaultState(): ISegmentsModuleState {
    return {
        segmentGroup: undefined,
        segmentWidgetAvailability: undefined,
        segmentsLoading: false,
        createUpdateGroupSegmentModalIsOpen: false,
        deleteSegmentGroupIsOpen: false,
        compareToSegment: undefined,
        shouldShowNoAccessModal: false,
        customSegmentsMeta: undefined,
        dashboardSegmentsMeta: undefined,
    };
}

function segmentsModule(incomingState: ISegmentsModuleState, action: FixmeType): ISegmentsModuleState {
    const state = incomingState || getDefaultState();

    switch (action.type) {
        case SHOW_NO_ACCESS_MODAL:
            return {
                ...state,
                shouldShowNoAccessModal: action.shouldShowNoAccessModal,
            };
        case RECEIVE_SEGMENTS_MODULE_META_DATA:
            return {
                ...state,
                customSegmentsMeta: action.customSegmentsMeta,
                segmentsLoading: action.segmentsLoading,
            };
        case SET_ENABLED_WIDGETS:
            return {
                ...state,
                segmentWidgetAvailability: action.segmentWidgetAvailability,
            };
        case RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA:
            return {
                ...state,
                dashboardSegmentsMeta: action.dashboardSegmentsMeta,
                segmentsLoading: action.segmentsLoading,
            };
        case UPDATE_UNIQUE_SEGMENTS_IDS:
            return {
                ...state,
                // @ts-ignore FIXME: strict migration — legacy spread may lack required DashboardSegmentsMeta fields
                dashboardSegmentsMeta: {
                    ...state.dashboardSegmentsMeta,
                    UniqueSegments: action.uniqueSegments,
                },
            };
        case REQUEST_SEGMENTS_MODULE_META_DATA:
            return {
                ...state,
                segmentsLoading: action.segmentsLoading,
            };
        case TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL:
            return {
                ...state,
                createUpdateGroupSegmentModalIsOpen: action.isOpen,
                segmentGroup: action.segmentGroup,
                compareToSegment: action.segmentToCompare,
            };
        case TOGGLE_DELETE_SEGMENT_GROUP_MODAL:
            return {
                ...state,
                deleteSegmentGroupIsOpen: action.isOpen,
                segmentGroup: action.segmentGroup,
            };
        case DELETE_SEGMENT_GROUP_SUCCESS:
            return {
                ...state,
                deleteSegmentGroupIsOpen: false,
                segmentGroup: undefined,
                // @ts-ignore FIXME: strict migration — legacy spread with possibly-undefined customSegmentsMeta
                customSegmentsMeta: {
                    ...state.customSegmentsMeta,
                    SegmentGroups: [
                        ...state.customSegmentsMeta!.SegmentGroups.filter(
                            (group) => group.id !== action.segmentGroup.id,
                        ),
                    ],
                },
            };
        case GROUP_CREATED_UPDATED:
            return {
                ...state,
                createUpdateGroupSegmentModalIsOpen: false,
                // @ts-ignore FIXME: strict migration — legacy spread with possibly-undefined customSegmentsMeta
                customSegmentsMeta: {
                    ...state.customSegmentsMeta,
                    SegmentGroups: [
                        ...state.customSegmentsMeta!.SegmentGroups.filter(
                            (group) => group.id !== action.segmentGroup.id,
                        ),
                        action.segmentGroup,
                    ],
                },
            };
        case GROUP_DELETED:
            return {
                ...state,
                // @ts-ignore FIXME: strict migration — legacy spread with possibly-undefined customSegmentsMeta
                customSegmentsMeta: {
                    ...state.customSegmentsMeta,
                    SegmentGroups: [
                        ...state.customSegmentsMeta!.SegmentGroups.filter((group) => group.id !== action.segmentGroupId),
                    ],
                },
            };
        case CUSTOM_SEGMENT_CREATED_UPDATED:
            return {
                ...state,
                // @ts-ignore FIXME: strict migration — legacy spread with possibly-undefined customSegmentsMeta
                customSegmentsMeta: {
                    ...state.customSegmentsMeta,
                    Segments: [
                        ...state.customSegmentsMeta!.Segments.filter((seg) => seg.id !== action.customSegment.id),
                        action.customSegment,
                    ],
                    AccountSegments: [
                        ...state.customSegmentsMeta!.AccountSegments.filter((seg) => seg.id !== action.customSegment.id),
                        action.customSegment,
                    ],
                },
            };
        default:
            return state;
    }
}

export default segmentsModule;
